// `type` stored on the File row for task attachments. Unknown reporting types
// map to the client's MiscReporting folder server-side (see files/Upload.ts),
// which is the desired destination for ad-hoc task attachments. Shared so the
// client upload path and the server-side Arc attach path agree on one value.
export const TASK_ATTACHMENT_FILE_TYPE = 'Task Attachment'

// The task module's product name (ACT = Atlas Tasks). Individual items are still "tasks".
export const TASKS_MODULE_NAME = 'ACT'

// The seeded Category custom field (see the migration that inserts it). Category
// moved out of its own `tasks.category` column and into the custom-field system.
//
// Nothing about this field is identified by a pinned uuid: the server resolves it
// by this name (global fields have their name locked — see customFields/Update),
// and the client gets its id from the categories endpoint at runtime. Renaming it
// is therefore a code change, not a UI action, which is the intended trade — too
// much is keyed on it being "Category".
export const TASK_CATEGORY_FIELD_NAME = 'Category'

// The field's selectable options, in display order.
//
// Deliberately NOT derived from the TaskCategory enum: that enum carries
// `AdHoc`, which no code path ever wrote to `tasks.category`. It meant "not tied
// to a process" — a statement about provenance, which `TaskSource` (Manual /
// Arc / Call) now owns. Offering it as a category would ask users to pick a
// value the system never assigned, so the option set is listed explicitly.
export const TASK_CATEGORY_OPTIONS: { name: string; color: string }[] = [
  { name: 'Funding', color: 'green' },
  { name: 'Collections', color: 'hot-pink' },
  { name: 'Reporting', color: 'blue' },
  { name: 'Flags Investigation', color: 'purple' },
  { name: 'BD Documents', color: 'aqua' },
  { name: 'DD Documents', color: 'orange' },
  { name: 'Committee Submission', color: 'indigo' },
  { name: 'Amendments', color: 'yellow-orange' },
  { name: 'Terms Approval', color: 'magenta' },
]

// Option ids are NOT pinned: they're generated at seed time and resolved by name
// at runtime. That's safe because these options are seeded `isSystem`, and
// `mergeOptions` rejects renaming/removing/disabling a system option — so the
// name is a stable contract without hardcoding uuids.
